import type { VizMode } from '../../config/schema';

export const G = 9.81;
export const G_SCULPTURE = 9.80665;
export const PI = 3.14159265359;
export const VIZ_DISTANCE = 0;
export const VIZ_POSITION = 1;
export const VIZ_DIVERGENCE = 2;
export const VIZ_DIVERGENCE_DISTANCE = 3;
export const VIZ_FURTHEST_NEIGHBOR = 4;
export const VIZ_TOTAL_NEIGHBOR = 5;
export const VIZ_TIME_TO_RETURN = 6;
export const VIZ_FTLE = 7;

export function vizModeToNumber(vm: VizMode): number {
  switch (vm) {
    case 'distance': return VIZ_DISTANCE;
    case 'position': return VIZ_POSITION;
    case 'divergence': return VIZ_DIVERGENCE;
    case 'divergenceDistance': return VIZ_DIVERGENCE_DISTANCE;
    case 'furthestNeighbor': return VIZ_FURTHEST_NEIGHBOR;
    case 'totalNeighborDistance': return VIZ_TOTAL_NEIGHBOR;
    case 'closenessOfReturn': return VIZ_TIME_TO_RETURN;
    case 'ftle': return VIZ_FTLE;
  }
}
